import { Message } from './type/Message';

type T = (to: Window, message: Message, target?: string) => void;

const f: T = (to, message, target = '*') => {
    to.postMessage(message, target);
};

export default f;
